import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { ConvertCurrencyPipe } from '../../_pipes/convertCurrency.pipe';
import { PriceConfigService } from '../../_services/price-config.service';
import { SdHtmlComponent } from '../html/html.component';

@Component({
  selector: 'sd-converted-price',
  templateUrl: './converted-price.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ConvertCurrencyPipe,
    SdHtmlComponent
  ]
})
export class SdConvertedPriceComponent {
  isDblCurrencyActivated = inject(PriceConfigService).dblCurrencyActivated;

  sourceCurrencyIsocode = input(undefined);
  displayComponent = input(true);
  price = input<string>();
  class = input<string>();
  textBeforePrice = input('');
}
